import { render, staticRenderFns } from "./index-centered.vue?vue&type=template&id=61674345&scoped=true"
import script from "./index-centered.vue?vue&type=script&lang=js"
export * from "./index-centered.vue?vue&type=script&lang=js"
import style0 from "./index-centered.vue?vue&type=style&index=0&id=61674345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61674345",
  null
  
)

export default component.exports